<template>
  <v-app>
    <router-view></router-view>
    <v-snackbar
      :class="`${getForAccessibility ? 'for-accessibility-app' : ''}`"
      :timeout="snackbar.timeout || 3000"
      app
      :bottom="getPosBottom"
      :left="getPosLeft"
      :centered="getPosCentered"
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      <!-- multiple object-->
      <template
        v-if="snackbar.multiple && multipleIsObject && objectElements >= 2"
      >
        <div
          v-for="(item, index) in Object.keys(snackbar.multiple)"
          :key="index"
        >
          <ul
            v-for="(subItem, subIndex) in snackbar.multiple[item]"
            :key="subIndex"
          >
            <li>
              <span>{{`${snackbar.fields ? snackbar.fields[item] : ''}: ${subItem}`}}</span>
            </li>
          </ul>
        </div>
      </template>
      <template
        v-else-if="snackbar.multiple && multipleIsObject && objectElements == 1"
      >
        <ul
          v-for="(item, index) in snackbar.multiple[
            Object.keys(snackbar.multiple)[0]
          ]"
          :key="index"
        >
          <span>{{`${snackbar.fields ? snackbar.fields[Object.keys(snackbar.multiple)[0]] + ':' : ''} ${item}`}}</span>
        </ul>
      </template>
      <!-- multiple array-->
      <template v-else-if="snackbar.multiple && snackbar.multiple.length >= 2">
        <ul v-for="(item, index) in snackbar.multiple" :key="index">
          <li>{{ item }}</li>
        </ul>
      </template>
      <template v-else-if="snackbar.multiple && snackbar.multiple.length == 1">
        {{ snackbar.multiple[0] }}
      </template>
      <!-- single -->
      <template v-else>
        {{ snackbar.text }}
      </template>

      <template v-slot:action="{ attrs }">
        <v-btn icon v-bind="attrs" @click="snackbar.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </v-app>
</template>

<script>
import catchErrors from './catchErrors'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  mixins: [catchErrors],
  data() {
    return {
      snackbar: {
        show: false,
        text: '',
        color: '',
      },
    }
  },
  computed: {
    ...mapGetters(['getForAccessibility']),
    getPosBottom() {
      return this.snackbar.color != 'error' && this.snackbar.color != 'info'
    },
    getPosLeft() {
      return this.snackbar.color != 'error' && this.snackbar.color != 'info'
    },
    getPosCentered() {
      return this.snackbar.color == 'error' || this.snackbar.color == 'info'
    },
    objectElements() {
      return (
        this.snackbar.multiple && Object.keys(this.snackbar.multiple).length
      )
    },
    multipleIsObject() {
      return !Array.isArray(this.snackbar.multiple);
    },
  },
}
</script>
